import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "fragments"
    }}>{`Fragments`}</h1>
    <p>{`Fragments are special tags which enables users to write a composition using text tags or other fragments. Fragments introduce re-usability among the tags and enable users to create multiple such compositions and use them in their templates.`}</p>
    <h2 {...{
      "id": "how-to-use-"
    }}>{`How to use ?`}</h2>
    <p>{`To use fragments in the API, user will need to create a `}<strong parentName="p">{`fragments`}</strong>{` json and pass it as a parameter in the api request body or they can use SDKs as well.`}</p>
    <p>{`Below is a json defining fragments related to an `}<strong parentName="p">{`address`}</strong>{` and a `}<strong parentName="p">{`name`}</strong>{` use-case.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "addressDetails" : "<br>{{streetDetails}}<br>{{localityDetails}}",
  "streetDetails":"<span style=\\"color: 0000FF;\\">{{addressline1}}<br>{{addressline2}}<br>{{addressline3}}",
  "localityDetails" : "<span style=\\"color: 006400;\\">{{city}},<i>{{state}}</i>-<b>{{pincode}}</b>",
  "fullname": "<span style=\\"color: ff0000;\\">{{firstname}} {{lastnameStyled}}",
  "lastnameStyled": "<span STYLE=\\"font-size:14mm\\"><b><i>{{lastname}}</i></b>"
}
`}</code></pre>
    <p>{`In the above json, we have defined fragments named `}<inlineCode parentName="p">{`addressDetails`}</inlineCode>{`, `}<inlineCode parentName="p">{`streetDetails`}</inlineCode>{`, `}<inlineCode parentName="p">{`localityDetails`}</inlineCode>{` related to the `}<strong parentName="p">{`address`}</strong>{` use-case and,  `}<inlineCode parentName="p">{`fullname`}</inlineCode>{` and `}<inlineCode parentName="p">{`lastnameStyled`}</inlineCode>{` for the `}<strong parentName="p">{`name`}</strong>{` use-case. Below is the explanation of the fragments defined above: `}</p>
    <p>{`The `}<inlineCode parentName="p">{`addressDetails`}</inlineCode>{` fragment composes `}<inlineCode parentName="p">{`streetDetails`}</inlineCode>{` and `}<inlineCode parentName="p">{`localityDetails`}</inlineCode>{` fragment tags.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`streetDetails`}</inlineCode>{` fragment composes `}<inlineCode parentName="p">{`addressline1`}</inlineCode>{`, `}<inlineCode parentName="p">{`addressline2`}</inlineCode>{` and `}<inlineCode parentName="p">{`addressline3`}</inlineCode>{` text tags.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`localityDetails`}</inlineCode>{` fragment composes `}<inlineCode parentName="p">{`state`}</inlineCode>{`, `}<inlineCode parentName="p">{`city`}</inlineCode>{` and `}<inlineCode parentName="p">{`pincode`}</inlineCode>{` text tags.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`fullname`}</inlineCode>{` fragment composes `}<inlineCode parentName="p">{`firstname`}</inlineCode>{` text tag and a `}<inlineCode parentName="p">{`lastnameStyled`}</inlineCode>{` fragment tag.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`lastnameStyled`}</inlineCode>{` fragment composes `}<inlineCode parentName="p">{`lastname`}</inlineCode>{` text tag.`}</p>
    <p>{`To resolve the text tags used in the above fragments, the `}<strong parentName="p">{`jsonDataForMerge`}</strong>{` json would be:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "addressline1": "Sample Address Line 1",
  "addressline2": "Sample Address Line 2",
  "addressline3": "Sample Address Line 3",
  "city": "Sample City",
  "state": "Sample State",
  "pincode": "42132xx",
  "zip": "Sample zip",
  "firstname": "John",
  "lastname": "Roy",
  "country": "India",
  "street": "Sample Street",
  "postcode": "Sample PostCode",
  "arr" : [1,2,3]
}
`}</code></pre>
    <p>{`There is one more way to define `}<strong parentName="p">{`fragments`}</strong>{` json which can be used to organize related fragments together and separate unrelated fragments into another object, then all such objects can be combined in a json array. `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`[
  {
    "addressDetails": "<br>{{streetDetails}}<br>{{localityDetails}}",
    "streetDetails": "<span style=\\"color: 0000FF;\\">{{addressline1}}<br>{{addressline2}}<br>{{addressline3}}",
    "localityDetails": "<span style=\\"color: 006400;\\">{{city}},<i>{{state}}</i>-<b>{{pincode}}</b>"
  },
  {
    "fullname": "<span style=\\"color: ff0000;\\">{{firstname}} {{lastnameStyled}}",
    "lastnameStyled": "<span STYLE=\\"font-size:14mm\\"><b><i>{{lastname}}</i></b>"
  }
]
`}</code></pre>
    <p>{`In the above json array, first json object corresponds to the `}<strong parentName="p">{`address`}</strong>{` related fragments and second for `}<strong parentName="p">{`name`}</strong>{` related fragments`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`To resolve the value of nested fragment like `}<inlineCode parentName="p">{`streetDetails`}</inlineCode>{` above, the same object containing the parent fragment i.e. `}<inlineCode parentName="p">{`addressDetails`}</inlineCode>{` will be looked up. This is how the nested fragments are resolved.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`If there are name collisions in the fragment keys within multiple objects, the first object (containing the key) in the list, will be used to resolve it.`}</p>
    <p>{`Below are the sample input and output documents snapshots describing the use of fragments.`}</p>
    <p>{`Here the `}<inlineCode parentName="p">{`addressDetails`}</inlineCode>{` fragment is used in the Word document template file.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "3.75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/bb631aa876f86b9ccc92f1fde952ccbf/5530d/address_input.webp 320w", "/document-services/docs/static/bb631aa876f86b9ccc92f1fde952ccbf/0c8fb/address_input.webp 640w", "/document-services/docs/static/bb631aa876f86b9ccc92f1fde952ccbf/94b1e/address_input.webp 1280w", "/document-services/docs/static/bb631aa876f86b9ccc92f1fde952ccbf/0b34d/address_input.webp 1920w", "/document-services/docs/static/bb631aa876f86b9ccc92f1fde952ccbf/4d98c/address_input.webp 2212w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/bb631aa876f86b9ccc92f1fde952ccbf/dd4a7/address_input.png 320w", "/document-services/docs/static/bb631aa876f86b9ccc92f1fde952ccbf/0f09e/address_input.png 640w", "/document-services/docs/static/bb631aa876f86b9ccc92f1fde952ccbf/bbbf7/address_input.png 1280w", "/document-services/docs/static/bb631aa876f86b9ccc92f1fde952ccbf/ac7a9/address_input.png 1920w", "/document-services/docs/static/bb631aa876f86b9ccc92f1fde952ccbf/d55ca/address_input.png 2212w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/bb631aa876f86b9ccc92f1fde952ccbf/bbbf7/address_input.png",
            "alt": "Address Input fragment",
            "title": "Address Input fragment",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`The output document generated will look like:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "9.375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/eb9f7592f203c7bf37034697a4375e03/5530d/address_output.webp 320w", "/document-services/docs/static/eb9f7592f203c7bf37034697a4375e03/0c8fb/address_output.webp 640w", "/document-services/docs/static/eb9f7592f203c7bf37034697a4375e03/94b1e/address_output.webp 1280w", "/document-services/docs/static/eb9f7592f203c7bf37034697a4375e03/0b34d/address_output.webp 1920w", "/document-services/docs/static/eb9f7592f203c7bf37034697a4375e03/9858b/address_output.webp 2116w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/eb9f7592f203c7bf37034697a4375e03/dd4a7/address_output.png 320w", "/document-services/docs/static/eb9f7592f203c7bf37034697a4375e03/0f09e/address_output.png 640w", "/document-services/docs/static/eb9f7592f203c7bf37034697a4375e03/bbbf7/address_output.png 1280w", "/document-services/docs/static/eb9f7592f203c7bf37034697a4375e03/ac7a9/address_output.png 1920w", "/document-services/docs/static/eb9f7592f203c7bf37034697a4375e03/f7edd/address_output.png 2116w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/eb9f7592f203c7bf37034697a4375e03/bbbf7/address_output.png",
            "alt": "Output of address fragment in document",
            "title": "Output of address fragment in document",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`Similarly,  the `}<inlineCode parentName="p">{`fullname`}</inlineCode>{` fragment can be used like this in the word document template file.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "3.75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/028445b0098e3b4092236aea6d57c6e9/5530d/name_input.webp 320w", "/document-services/docs/static/028445b0098e3b4092236aea6d57c6e9/0c8fb/name_input.webp 640w", "/document-services/docs/static/028445b0098e3b4092236aea6d57c6e9/94b1e/name_input.webp 1280w", "/document-services/docs/static/028445b0098e3b4092236aea6d57c6e9/0b34d/name_input.webp 1920w", "/document-services/docs/static/028445b0098e3b4092236aea6d57c6e9/d2cb1/name_input.webp 2216w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/028445b0098e3b4092236aea6d57c6e9/dd4a7/name_input.png 320w", "/document-services/docs/static/028445b0098e3b4092236aea6d57c6e9/0f09e/name_input.png 640w", "/document-services/docs/static/028445b0098e3b4092236aea6d57c6e9/bbbf7/name_input.png 1280w", "/document-services/docs/static/028445b0098e3b4092236aea6d57c6e9/ac7a9/name_input.png 1920w", "/document-services/docs/static/028445b0098e3b4092236aea6d57c6e9/7a54e/name_input.png 2216w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/028445b0098e3b4092236aea6d57c6e9/bbbf7/name_input.png",
            "alt": "Name Input fragment",
            "title": "Name Input fragment",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`And the output document generated will look like:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "4.375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/c40256836008d0e524fcc0d4f90fcaf3/5530d/name_output.webp 320w", "/document-services/docs/static/c40256836008d0e524fcc0d4f90fcaf3/0c8fb/name_output.webp 640w", "/document-services/docs/static/c40256836008d0e524fcc0d4f90fcaf3/94b1e/name_output.webp 1280w", "/document-services/docs/static/c40256836008d0e524fcc0d4f90fcaf3/0b34d/name_output.webp 1920w", "/document-services/docs/static/c40256836008d0e524fcc0d4f90fcaf3/9d55f/name_output.webp 2166w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/c40256836008d0e524fcc0d4f90fcaf3/dd4a7/name_output.png 320w", "/document-services/docs/static/c40256836008d0e524fcc0d4f90fcaf3/0f09e/name_output.png 640w", "/document-services/docs/static/c40256836008d0e524fcc0d4f90fcaf3/bbbf7/name_output.png 1280w", "/document-services/docs/static/c40256836008d0e524fcc0d4f90fcaf3/ac7a9/name_output.png 1920w", "/document-services/docs/static/c40256836008d0e524fcc0d4f90fcaf3/e058c/name_output.png 2166w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/c40256836008d0e524fcc0d4f90fcaf3/bbbf7/name_output.png",
            "alt": "Output of name fragment in document",
            "title": "Output of name fragment in document",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "other-supported-constructs"
    }}>{`Other supported constructs`}</h2>
    <h3 {...{
      "id": "conditionals"
    }}>{`Conditionals`}</h3>
    <p>{`Evaluate value of fragments based on the conditions.`}</p>
    <p>{`JSON representation of the input data:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`[
  {
    "addressDetails": "<br>{{streetDetails}}<br>{{localityDetails}}",
    "streetDetails": "<span style=\\"color: 0000FF;\\">{{addressline1}}<br>{{addressline2}}<br>{{addressline3}}</span>",
    "localityDetails": "<span style=\\"color: 006400;\\">{% conditional-section expr(country=\\"India\\") %}{{street}} {{postcode}} {{city}},<i>{{country}}</i> {% end-section %}{% conditional-section expr(country=\\"USA\\") %}{{street}}{{city}} {{state}} {{zip}},<i>{{country}}</i> {% end-section %}</span>"
  },
  {
    "fullname": "<span style=\\"color: ff0000;\\">{{firstname}} {{lastnameStyled}}</span>",
    "lastnameStyled": "<span STYLE=\\"font-size:14mm\\"><b><i>{{lastname}}</i></b></span>"
  }
]
`}</code></pre>
    <p>{`The `}<inlineCode parentName="p">{`localityDetails`}</inlineCode>{` fragment contains a conditional phrase that is evaluated based on the `}<inlineCode parentName="p">{`country`}</inlineCode>{` text tag.
The format of `}<inlineCode parentName="p">{`localityDetails`}</inlineCode>{` for India is
`}<inlineCode parentName="p">{`street`}</inlineCode>{`
`}<inlineCode parentName="p">{`postCode`}</inlineCode>{` `}<inlineCode parentName="p">{`city`}</inlineCode>{`,
`}<inlineCode parentName="p">{`country`}</inlineCode>{`. The format of `}<inlineCode parentName="p">{`localityDetails`}</inlineCode>{` for the USA is
`}<inlineCode parentName="p">{`street`}</inlineCode>{`
`}<inlineCode parentName="p">{`city`}</inlineCode>{` `}<inlineCode parentName="p">{`state`}</inlineCode>{` `}<inlineCode parentName="p">{`zip`}</inlineCode>{`,
`}<inlineCode parentName="p">{`country`}</inlineCode>{`.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "8.75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/91769c650b7a67ac98699eecb2f6d812/5530d/fragments-condition.webp 320w", "/document-services/docs/static/91769c650b7a67ac98699eecb2f6d812/0c8fb/fragments-condition.webp 640w", "/document-services/docs/static/91769c650b7a67ac98699eecb2f6d812/94b1e/fragments-condition.webp 1280w", "/document-services/docs/static/91769c650b7a67ac98699eecb2f6d812/0b34d/fragments-condition.webp 1920w", "/document-services/docs/static/91769c650b7a67ac98699eecb2f6d812/936ba/fragments-condition.webp 2414w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/91769c650b7a67ac98699eecb2f6d812/dd4a7/fragments-condition.png 320w", "/document-services/docs/static/91769c650b7a67ac98699eecb2f6d812/0f09e/fragments-condition.png 640w", "/document-services/docs/static/91769c650b7a67ac98699eecb2f6d812/bbbf7/fragments-condition.png 1280w", "/document-services/docs/static/91769c650b7a67ac98699eecb2f6d812/ac7a9/fragments-condition.png 1920w", "/document-services/docs/static/91769c650b7a67ac98699eecb2f6d812/de83e/fragments-condition.png 2414w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/91769c650b7a67ac98699eecb2f6d812/bbbf7/fragments-condition.png",
            "alt": "Output of fragment with condition in document",
            "title": "Output of fragment with condition in document",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "optional"
    }}>{`Optional`}</h3>
    <p>{`Setting a tag inside the fragment as `}<em parentName="p">{`optional`}</em>{` will replace the tag with an empty string if it is not present either in input or fragment json data.`}</p>
    <p>{`JSON representation of the input data:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`[
  {
    "fullname": "{{firstname}} {{middlename:optional(true)}} {{lastname}}"
  },
  {
    ...
  }
]
`}</code></pre>
    <p>{`In the above fragment, there is an optional property used with `}<inlineCode parentName="p">{`middlename`}</inlineCode>{` tag. Since the optional property is set to true, the `}<inlineCode parentName="p">{`middlename`}</inlineCode>{` tag will be replaced by an empty string if it does not exist.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "8.4375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/98eeb37b60f1e83f1e89d406c81c9197/5530d/fragments-optional.webp 320w", "/document-services/docs/static/98eeb37b60f1e83f1e89d406c81c9197/0c8fb/fragments-optional.webp 640w", "/document-services/docs/static/98eeb37b60f1e83f1e89d406c81c9197/94b1e/fragments-optional.webp 1280w", "/document-services/docs/static/98eeb37b60f1e83f1e89d406c81c9197/0b34d/fragments-optional.webp 1920w", "/document-services/docs/static/98eeb37b60f1e83f1e89d406c81c9197/936ba/fragments-optional.webp 2414w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/98eeb37b60f1e83f1e89d406c81c9197/dd4a7/fragments-optional.png 320w", "/document-services/docs/static/98eeb37b60f1e83f1e89d406c81c9197/0f09e/fragments-optional.png 640w", "/document-services/docs/static/98eeb37b60f1e83f1e89d406c81c9197/bbbf7/fragments-optional.png 1280w", "/document-services/docs/static/98eeb37b60f1e83f1e89d406c81c9197/ac7a9/fragments-optional.png 1920w", "/document-services/docs/static/98eeb37b60f1e83f1e89d406c81c9197/de83e/fragments-optional.png 2414w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/98eeb37b60f1e83f1e89d406c81c9197/bbbf7/fragments-optional.png",
            "alt": "Output of fragment with optional value in document",
            "title": "Output of fragment with optional value in document",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "default"
    }}>{`Default`}</h3>
    <p>{`A `}<em parentName="p">{`default value`}</em>{` can be specified for a tag inside the fragment. `}</p>
    <p>{`JSON representation of the input data:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`[
  {
    "team": "ABC, {{organisation:default-val(\\"Org\\")}}"
  },
  {
    ...
  }
]
`}</code></pre>
    <p>{`In the above fragment, if the `}<inlineCode parentName="p">{`organisation`}</inlineCode>{` tag does not exist either in input or fragment json data, then default value (i.e. "Org") will be used.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "8.4375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/e8075559771ed59eb54ed7c7dc90caa5/5530d/fragments-default.webp 320w", "/document-services/docs/static/e8075559771ed59eb54ed7c7dc90caa5/0c8fb/fragments-default.webp 640w", "/document-services/docs/static/e8075559771ed59eb54ed7c7dc90caa5/94b1e/fragments-default.webp 1280w", "/document-services/docs/static/e8075559771ed59eb54ed7c7dc90caa5/0b34d/fragments-default.webp 1920w", "/document-services/docs/static/e8075559771ed59eb54ed7c7dc90caa5/936ba/fragments-default.webp 2414w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/e8075559771ed59eb54ed7c7dc90caa5/dd4a7/fragments-default.png 320w", "/document-services/docs/static/e8075559771ed59eb54ed7c7dc90caa5/0f09e/fragments-default.png 640w", "/document-services/docs/static/e8075559771ed59eb54ed7c7dc90caa5/bbbf7/fragments-default.png 1280w", "/document-services/docs/static/e8075559771ed59eb54ed7c7dc90caa5/ac7a9/fragments-default.png 1920w", "/document-services/docs/static/e8075559771ed59eb54ed7c7dc90caa5/de83e/fragments-default.png 2414w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/e8075559771ed59eb54ed7c7dc90caa5/bbbf7/fragments-default.png",
            "alt": "Output of fragment with default value in document",
            "title": "Output of fragment with default value in document",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "prefix"
    }}>{`Prefix`}</h3>
    <p>{`A `}<em parentName="p">{`prefix value`}</em>{` can be specified for a tag inside the fragment.`}</p>
    <p>{`JSON representation of the input data:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`[
  {
    "doctor": "{{doctorName:prefix(\\"Dr. \\")}}",
    "doctorName": "{{firstname}} {{lastname}}"
  },
  {
    ...
  }
]
`}</code></pre>
    <p>{`In the above fragment, `}<inlineCode parentName="p">{`doctor`}</inlineCode>{` tag further contains `}<inlineCode parentName="p">{`doctorName`}</inlineCode>{` tag, to which a prefix value is specified. So, the prefix value (i.e. "Dr. ") will be added before the value of the `}<inlineCode parentName="p">{`doctorName`}</inlineCode>{` tag in the output.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "8.4375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/afd9d05e53c2e4e17fd85b3b5afa6cc3/5530d/fragments-prefix.webp 320w", "/document-services/docs/static/afd9d05e53c2e4e17fd85b3b5afa6cc3/0c8fb/fragments-prefix.webp 640w", "/document-services/docs/static/afd9d05e53c2e4e17fd85b3b5afa6cc3/94b1e/fragments-prefix.webp 1280w", "/document-services/docs/static/afd9d05e53c2e4e17fd85b3b5afa6cc3/0b34d/fragments-prefix.webp 1920w", "/document-services/docs/static/afd9d05e53c2e4e17fd85b3b5afa6cc3/936ba/fragments-prefix.webp 2414w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/afd9d05e53c2e4e17fd85b3b5afa6cc3/dd4a7/fragments-prefix.png 320w", "/document-services/docs/static/afd9d05e53c2e4e17fd85b3b5afa6cc3/0f09e/fragments-prefix.png 640w", "/document-services/docs/static/afd9d05e53c2e4e17fd85b3b5afa6cc3/bbbf7/fragments-prefix.png 1280w", "/document-services/docs/static/afd9d05e53c2e4e17fd85b3b5afa6cc3/ac7a9/fragments-prefix.png 1920w", "/document-services/docs/static/afd9d05e53c2e4e17fd85b3b5afa6cc3/de83e/fragments-prefix.png 2414w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/afd9d05e53c2e4e17fd85b3b5afa6cc3/bbbf7/fragments-prefix.png",
            "alt": "Output of fragment with prefix in document",
            "title": "Output of fragment with prefix in document",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "limitations"
    }}>{`Limitations`}</h2>
    <ul>
      <br />
      <li>The Expressions and Jsonata functions are not supported inside the fragments.</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      